<template>
  <section id="popover">
    <div class="demo">
      <div class="row">
        <div class="col-md-6">
          <div class="popover popover-arrow-bl position-relative" role="dialog" aria-describedby="popDemo1_body">
            <button type="button" class="close" title="Close" aria-label="Close"><i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i></button> 
            <span class="pointer"></span>
            <div id="popDemo1_body"> 
              <h3>Some heading</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> 
              <button class="btn btn-primary btn-sm">Action</button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="popover popover-arrow-tl popover-info position-relative" role="dialog" aria-describedby="popDemo1_body">
            <button type="button" class="close" title="Close" aria-label="Close"><i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i></button> 
            <span class="pointer"></span>
            <div id="popDemo2_body"> 
              <h3 class="text-white">Some heading</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> 
              <button class="btn btn-outline-primary btn-sm">Action</button>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <div class="popover popover-arrow-lt position-relative" role="dialog" aria-describedby="popDemo1_body">
            <button type="button" class="close" title="Close" aria-label="Close"><i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i></button> 
            <span class="pointer"></span>
            <div id="popDemo1_body" class="d-flex">
              <img width="45px" class="mr-3" src="@/assets/gel/images/illustrations/bulb.svg" alt="Jobs panel"> 
              <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor <a href="#" class=" text-underline">incididuntut labore </a>et dolore magna aliqua. </div></div>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <div class="popover popover-arrow-rt popover-info position-relative" role="dialog" aria-describedby="popDemo1_body">
            <button type="button" class="close" title="Close" aria-label="Close"><i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i></button> 
            <span class="pointer"></span>
            <div id="popDemo2_body"> Lorem ipsum dolor sit amet, <a href="#" class="text-white">consectetur adipiscing</a> elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </div>
        </div>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/components/popover.md";

export default {
  name: "popover",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.popover.name);
    this.$emit("update-tagline", this.$root.yamlData.components.popover.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
